import React from 'react';

const CreditCardsSelectType = ({ input, translate, meta: { touched, error, warning, asyncValidating } }) => {
  return(
    <div>
      <select {...input} className="form-control ng-pristine ng-untouched ng-valid ng-empty" size="size">
        <option value="" hidden="hidden"> </option>
        <option value="VISA">VISA</option>
        <option value="MASTERCARD">MASTERCARD</option>
        <option value="ISRACARD">ISRACARD</option>
        <option value="AMEX">AMEX</option>
        <option value="DINERS">DINERS</option>
      </select>
      {touched && error && <div><span className="text-danger">{translate(error)}</span></div>}
    </div>

  )
}
export default CreditCardsSelectType



// WEBPACK FOOTER //
// ./src/components/Payment/CreditCardsSelectType.js